export default __webpack_public_path__ + "static/media/ic-reduce-black.4c4cec6d.svg";